import { findAgents } from '../../services/agents-service'

export default {
  name: 'agent-selector',
  props: {
    childProps: Object,
    value: Object,
    resultLimit: Number,
    delay: Number,
    initialSearchKeyword: String
  },
  data () {
    return {
      selectedAgent: null,
      agents: [],
      apiInProgress: false,
      searchKeywords: ''
    }
  },
  mounted () {
    if (this.$props.value) {
      this.selectedAgent = this.$props.value
    }

    this.searchAgents()
  },
  watch: {
    selectedAgent: function (newVal) {
      this.$emit('input', newVal)
    },
    initialSearchKeyword (val) {
      if (val && !this.searchingInInitialSearchKeyword) {
        this.searchKeywords = val
        this.searchingInInitialSearchKeyword = true
        this.apiInProgress = true

        this.searchAgents().then(() => {
          if (this.agents?.length === 1) {
            this.selectedAgent = { ...this.agents[0] }
          }
        }).finally(() => {
          this.apiInProgress = false
          this.searchingInInitialSearchKeyword = false
        })
      }
    },
    searchKeywords (val) {
      clearTimeout(this.searchKeywordsHandle)
      if (val) {
        this.searchKeywordsHandle = setTimeout(() => {
          this.apiInProgress = true

          this.searchAgents()
            .finally(() => {
              this.apiInProgress = false
            })
        }, this.$props.delay || 800)
      }
    },
    value (val) {
      this.selectedAgent = val
    }
  },
  methods: {
    customFilter (item, queryText, itemText) {
      if (!queryText) return true

      const query = queryText.toLowerCase()
      const fullName = (item.fullName || '').toLowerCase()
      const phone = (item.phone || '').toLowerCase()
      const email = (item.email || '').toLowerCase()

      return fullName.includes(query) ||
             phone.includes(query) ||
             email.includes(query)
    },
    async searchAgents () {
      const agents = await findAgents({
        keywords: this.searchKeywords,
        page: 1,
        limit: this.$props.resultLimit || 10,
        sort: 'dateUpdated',
        order: 'DESC'
      })

      this.agents = agents.map(agent => {
        agent.fullName = `${agent.stUser.firstName} ${agent.stUser.lastName}`
        agent.phone = agent.stUser.phone
        agent.email = agent.stUser.email
        return agent
      })
    }
  },
  beforeDestroy () {
    clearTimeout(this.searchKeywordsHandle)
  }
}
